import { ClientProject } from '../features/clients/Clients.types';
import { getUrlWithId, useGetFetch } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export type ClientEmployeeType = {
  uuid: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  projects: ClientProject[];
};

export type FetchEmployeesResponseType = {
  count: number;
  results: ClientEmployeeType[];
};

export const useGetClientEmployees = (id: string) => {
  return useGetFetch<ClientEmployeeType[]>({
    url: getUrlWithId(ApiRoutesEnum.getClient, id).concat('/employees'),
    config: { enabled: !!id },
  });
};
